export default __webpack_public_path__ + "wp-content/uploads/react/user-dashboard/media/icomoon.be33d2fc.eot";